<div class="text-end mb-2">
	<button type="button" (click)="zoomDown()" class="me-2 btn rounded-pill btn-secondary waves-effect waves-light">-</button>
	<button type="button" (click)="zoomUp()" class="btn rounded-pill btn-secondary waves-effect waves-light">+</button>
</div>
<pdf-viewer
	[src]="eulaPDF"
	[render-text]="false"
	[show-all]="true"
	[original-size]="false"
	[autoresize]="true"
	[zoom]="zoom"
	[zoom-scale]="'page-width'"
	>
</pdf-viewer>